import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-primary",
  role: "alert"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "col-md-6 mx-auto" }
const _hoisted_5 = {
  key: 0,
  id: "passwordHelpBlock",
  class: "form-text"
}
const _hoisted_6 = { class: "mx-auto text-center" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "alert alert-primary mt-2",
  role: "alert"
}
const _hoisted_9 = ["innerHTML"]

import { ref, computed } from "vue";
import { app } from "../../ts/app";
import { Retiree } from "@/guiide/ts/retiree";
import { useStore } from "vuex";
import { decodeEncodedHtml } from "../../ts/utilities";
import TextInput from "../common/TextInput.vue";
import Modal from "@/guiide/components/common/Modal.vue";
import HttpStatusCode from "@/shared/ts/httpStatusCode";
import Constants from "@/guiide/ts/constants";
import AccountRegistrationBehaviour from "@/guiide/ts/accountRegistrationBehaviour";

type SignUpConfig = { canRegister: boolean, prompt: string, displayMotivation: boolean, completedMessage: string, dashboardResource: string, buttonText: string, showSecondaryAdvice: boolean };


export default /*@__PURE__*/_defineComponent({
  __name: 'Register',
  props: {
    retiree: {
        type: Object as () => Retiree | null,
        default: () => null,
    },
},
  setup(__props, { expose: __expose }) {

const props = __props;

const store = useStore();
const showRegistrationFailure = ref(false);
const registrationFailureMessage = ref("");
const emailServiceIssuesModal = ref(null);
const registering = ref(false);
const emailModel = ref("");
const emailInput = ref(null);
const registerButton = ref(null);

function alert() {
    if (registerButton.value) {
        registerButton.value.classList.add('shake');
        setTimeout(() => {
            registerButton.value?.classList.remove('shake');
        }, 1000);
    }
}

const signupConfig = computed<SignUpConfig>(() => {
    const config = store.state.configuration;

    const decodedPrompt = decodeEncodedHtml(config.signupPrompt);
    const showSecondaryAdvice = config.signupBehaviour == AccountRegistrationBehaviour.LinkEmailToAccount;

    return {
        canRegister: config.allowsSignup,
        prompt: decodedPrompt,
        displayMotivation: config.signupMotivationDisplayed,
        showSecondaryAdvice,
        buttonText: config.signupButtonText,
        completedMessage: config.signupCompletedMessage,
        dashboardResource: config.nav.track.resource
    };
});

const isRegistered = computed<boolean>(() => {
    return props.retiree?.isRegistered ?? true;
});

const displayRegistration = computed<boolean>(() => {
    return signupConfig.value.canRegister && !isRegistered.value && !hasStartedRegistrationProcess.value;
});

const showDashboardAdvert = computed<boolean>(() => {
    const config = store.state.configuration;
    return config.finishDisplaysNextButton && hasStartedRegistrationProcess.value;
});

const hasStartedRegistrationProcess = computed<boolean>(() => { return store.state.hasStartedRegistration; });

async function onRegisterClick() {
    if (!emailInput.value.isValid()) {
        return;
    }

    if (emailModel.value.includes("btinternet") || emailModel.value.includes("btopenworld")) {
        emailServiceIssuesModal.value.showModal();
        return;
    }

    await registerEmail();
}

async function onEmailServiceIssuesModalOk() {
    emailServiceIssuesModal.value.closeModal();
    await registerEmail();
}

async function registerEmail() {
    registering.value = true;
    showRegistrationFailure.value = false;
    registrationFailureMessage.value = "";

    const registrationResponse = await app.registerEmail(emailModel.value);

    if (registrationResponse.status != HttpStatusCode.Ok) {
        showRegistrationFailure.value = true;
        registrationFailureMessage.value = registrationResponse.message;
    }

    registering.value = false;
}

function onGuiidePlusClick() {
    window.location.href = `/${signupConfig.value.dashboardResource}`;
}

__expose({
    alert
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (displayRegistration.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (signupConfig.value.displayMotivation)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-info-circle-fill me-2" }, null, -1)),
                _createElementVNode("span", {
                  innerHTML: signupConfig.value.prompt
                }, null, 8, _hoisted_3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              ref_key: "emailInput",
              ref: emailInput,
              modelValue: emailModel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailModel).value = $event)),
              description: "Email",
              regex: _unref(Constants).RegularExpressions.Email,
              "key-press-regex": _unref(Constants).RegularExpressions.EmailChars
            }, null, 8, ["modelValue", "regex", "key-press-regex"]),
            (signupConfig.value.showSecondaryAdvice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " We will send you a link to set up a secure password. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                ref_key: "registerButton",
                ref: registerButton,
                class: "btn btn-primary mt-2 ms-3 w-auto border",
                onClick: onRegisterClick,
                disabled: registering.value
              }, _toDisplayString(signupConfig.value.buttonText), 9, _hoisted_7)
            ]),
            (showRegistrationFailure.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "bi bi-exclamation-circle-fill" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(registrationFailureMessage.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (hasStartedRegistrationProcess.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: "alert alert-success",
            role: "alert",
            innerHTML: signupConfig.value.completedMessage
          }, null, 8, _hoisted_9),
          (showDashboardAdvert.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[3] || (_cache[3] = _createElementVNode("p", null, " You can see our new Dashboard, Track and Help page by clicking the button below. ", -1)),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  onClick: onGuiidePlusClick
                }, "Dashboard")
              ], 64))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(Modal, {
      title: "Email service provider issue",
      ref_key: "emailServiceIssuesModal",
      ref: emailServiceIssuesModal,
      "id-key": "emailServiceIssues",
      showClose: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { class: "flex-container" }, [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Users tell us password setup and forgot password emails to BT addresses are not being received due to BT filters. To fix this, in your email:", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("ol", null, [
            _createElementVNode("li", null, "From the Settings tab, select the \"Safe senders\" folder and click on the Add button."),
            _createElementVNode("li", null, "Add the email address (contact@guiide.co.uk) you want to mark as safe and click Save."),
            _createElementVNode("li", null, "After a confirmation message the email address will be added to your list of safe senders.")
          ], -1)),
          _createElementVNode("div", { class: "buttons-wrapper mt-3 mb-3" }, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary float-end",
              onClick: onEmailServiceIssuesModalOk
            }, "Ok, I've fixed it")
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})